import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { FormGroup, Input, Col, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Loader } from '..';
import { resetWalletsUpdate, updateWallets } from '../../redux';
import { Utils } from '../../services';
import { Dropdown } from 'semantic-ui-react';

import './WalletsManager.css';

const WalletsManager = ({ show, onClose, ticketIds }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();
    const currency = Utils.currency();

    const [mode, setMode]     = useState(null);
    const [amount, setAmount] = useState(0);

    const {
        updatedWallets, isUpdatingWallets,
        updatingWalletsErrorMessage
    } = useSelector(state => state.tickets);
    const { setting } = useSelector(state => state.settings);

    useEffect(() => {
        dispatch(resetWalletsUpdate());
    }, []);

    console.log({ updatedWallets,isUpdatingWallets,updatingWalletsErrorMessage });
    const submit = () => {
        dispatch(updateWallets(ticketIds, mode, amount));
    }

    const modesOptions = Utils.creditWalletModes().map(mode => ({
        value: mode,
        text: t(`tickets.credit_wallet.modes.${mode}`),
    }));

    const onChangeMode = (e, data) => {
        setMode(data.value);
        console.log({ mode });
    };

    const showError = result => {
        if (!result.error)
            return null;

        return t(`tickets.credit_wallet.results.errors.${result.error}`);
    }

    const showAmount = (amount, withOperator) => {
        if (!amount)
            return null;

        return `${withOperator && amount > 0 ? '+' : ''}${amount?.toFixed(2)} ${Utils.currency()}`;
    }

    return (
        <div className="WalletsManager">
            <Modal isOpen={show} toggle={onClose}>
                <ModalHeader toggle={onClose}>
                    {t('tickets.credit_wallet.title')}
                </ModalHeader>
                <ModalBody>
                    {!isUpdatingWallets && !updatedWallets && (
                        <h4>
                            { t('tickets.credit_wallet.tickets_desc', {nb: ticketIds?.length}) }
                        </h4>
                    )}

                    {isUpdatingWallets && <Loader color="#000000" /> }

                    {!isUpdatingWallets && updatedWallets && (
                    <div>
                        <table className="table table-bordered table-striped">
                            <tr>
                                <th>{ t('tickets.credit_wallet.results.title') }</th>
                                <th className="text-center">{ t('tickets.credit_wallet.results.from') }</th>
                                <th className="text-center">{ t('tickets.credit_wallet.results.delta') }</th>
                                <th className="text-center">{ t('tickets.credit_wallet.results.to') }</th>
                                <th width="70px"></th>
                            </tr>
                            {updatedWallets?.map(result => (
                                <tr className={`${result.error ? 'bg-danger text-white' : ''}`}>
                                    <td>
                                        <i className="fa fa-tag" />&nbsp;
                                        { result.title ?? result._id }
                                        {result?.error && (
                                        <div><b>{showError(result)}</b></div>
                                        )}
                                    </td>
                                    <td className="text-center">{ showAmount(result.from) }</td>
                                    <td className="text-center">{ showAmount(result.delta, true) }</td>
                                    <td className="text-center">{ showAmount(result.to) }</td>
                                    <td className="text-center" width="70px">
                                        <Button
                                            color="primary"
                                            href={`${setting?.eshop?.uri}/ticket/view/?uuid=${result._id}`}
                                            target="_blank"
                                        >
                                            <i className="fa fa-external-link"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </table>
                    </div>
                    )}

                    {!isUpdatingWallets && updatingWalletsErrorMessage && (
                        <div className="alter alert-danger">
                            { updatingWalletsErrorMessage }
                        </div>
                    )}

                    {!isUpdatingWallets && !updatedWallets && (
                        <>
                            <FormGroup row>
                                <Label for="mode" sm={12}>{t("tickets.credit_wallet.what_do_you_want_to_do")}</Label>
                                <Col sm={12}>
                                    <Dropdown
                                        name="mode"
                                        options={ modesOptions }
                                        onChange={ onChangeMode }
                                        placeholder={ t('tickets.credit_wallet.please_choose_an_action') }
                                        className="form-control"
                                        selection
                                    />
                                </Col>
                            </FormGroup>
                            {mode && (
                                <FormGroup row>
                                    <Label for="amount" sm={12}>
                                        {mode === Utils.CREDIT_WALLET_MODE_CREDIT && t("tickets.credit_wallet.how_much_to_credit")}
                                        {mode === Utils.CREDIT_WALLET_MODE_DEBIT && t("tickets.credit_wallet.how_much_to_debit")}
                                        {[Utils.CREDIT_WALLET_MODE_REACH, Utils.CREDIT_WALLET_MODE_REACH_FROM_BALANCE].includes(mode) && t("tickets.credit_wallet.how_much_to_reach")}
                                    </Label>
                                    <Col sm={12}>
                                        <Input
                                            name="amount"
                                            type="number"
                                            min={0}
                                            step={0.01}
                                            onChange={ e => setAmount(e.target.value) }
                                            value={amount}
                                            placeholder={ t('tickets.credit_wallet.please_enter_an_amount') }
                                            className="form-control"
                                        />
                                    </Col>
                                </FormGroup>
                            )}
                        </>
                    )}
                </ModalBody>
                <ModalFooter>
                    {mode && !updatedWallets && (
                        <Button color="primary" disabled={!mode || !(amount >= 0)} onClick={ submit } >
                            <i className="fa fa-bolt"></i>&nbsp;
                            {t(`tickets.credit_wallet.${mode === Utils.CREDIT_WALLET_MODE_DEBIT ? 'debit' : 'credit'}`)}
                        </Button>
                    )}
                    <Button color="secondary" onClick={onClose}>
                        <i className="fa fa-close"></i>&nbsp;
                        {t('common.cancel')}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default WalletsManager;

